import { createTheme } from "@mui/material/styles";

export const paletteLightTheme = createTheme({
  palette: {
    primary: {
      main: "#01657F",
      light: "#01657F44",
      "900": "#006580",
      "700": "#338499",
      "500": "#66A3B3",
      "300": "#99C1CC",
      "100": "#CCE0E6",
      "50": "#E6F0F3",
    },
    error: {
      main: "#C35245",
      "700": "#C35245",
      "400": "#E1A9A2",
      "100": "#F9EEED",
    },
    success: {
      main: "#15803D",
      "700": "#15803D",
      "400": "#8AC09E",
      "100": "#E8F3EC",
    },
    secondary: {
      main: "#7CA392",
    },
    bgColor: {
      main: "#FFFFFF",
      light: "#FFFFFF",
      dark: "#FFFFFF",
      contrastText: "#FFFFFF",
    },
    light: {
      main: "#FFFFFF",
      light: "#FFFFFF",
      dark: "#FFFFFF",
      contrastText: "#FFFFFF",
    },
    dark: {
      main: "#222222",
      light: "#222222",
      dark: "#222222",
      contrastText: "#222222",
    },
    border: {
      main: "#D5DEE5",
      light: "#D5DEE5",
      dark: "#D5DEE5",
      contrastText: "#D5DEE5",
    },
    secondaryText: {
      main: "#697586",
      light: "#697586",
      dark: "#697586",
      contrastText: "#697586",
    },
    neutral: {
      main: "#20272B",
      light: "#44484F",
      dark: "#20272B",
      contrastText: "#20272B",
      "900": "#20272B",
      "700": "#44484F",
      "500": "#697586",
      "300": "#9AA4B2",
      "100": "#D5DEE5",
      "50": "#EDF5FA",
    },
    gGrey: {
      main: "#333333",
      light: "#333333",
      dark: "#333333",
      contrastText: "#333333",
      "900": "#20272B",
      "700": "#4F4F4F",
      "500": "#828282",
      "300": "#BDBDBD",
      "100": "#E0E0E0",
      "50": "#ECECEC",
    },
    greyBg: {
      main: "#333333",
      light: "#333333",
      dark: "#333333",
      contrastText: "#333333",
      "200": "#F1F0EC",
      "100": "#F8F8F8",
    },
    neutralBg: {
      main: "#333333",
      light: "#333333",
      dark: "#333333",
      contrastText: "#333333",
      "200": "#D3DCE3",
      "100": "#F1F6FA",
    },
    primaryDark: {
      main: "#163F4A",
      light: "#163F4A",
      dark: "#163F4A",
      contrastText: "#163F4A",
      "900": "#163F4A",
      "700": "#31535F",
      "500": "#4B6873",
      "300": "#657B89",
      "100": "#7F909D",
      "50": "#8D9AA8",
    },
    orange: {
      main: "#D5864E",
      light: "#D5864E",
      dark: "#D5864E",
      contrastText: "#D5864E",
      "700": "#D5864E",
      "400": "#E6B695",
      "100": "#F7E7DC",
    },
    info: {
      main: "#007BFF",
      light: "#007BFF",
      dark: "#007BFF",
      contrastText: "#007BFF",
      "700": "#007BFF",
      "400": "#007BFF",
      "100": "#E6F2FF",
    },
  },
});

export const paletteDarkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#328399",
      light: "#1E2B2F",
    },
    secondary: {
      main: "#489F84",
    },
    error: {
      main: "#DE3E32",
    },
    success: {
      main: "#5DAB60",
    },
    bgColor: {
      main: "#FFFFFF",
      light: "#FFFFFF",
      dark: "#FFFFFF",
      contrastText: "#FFFFFF",
    },
    light: {
      main: "#FFFFFF",
      light: "#FFFFFF",
      dark: "#FFFFFF",
      contrastText: "#FFFFFF",
    },
    dark: {
      main: "#222222",
      light: "#222222",
      dark: "#222222",
      contrastText: "#222222",
    },
    border: {
      main: "#D5DEE5",
      light: "#D5DEE5",
      dark: "#D5DEE5",
      contrastText: "#D5DEE5",
    },
    secondaryText: {
      main: "#697586",
      light: "#697586",
      dark: "#697586",
      contrastText: "#697586",
    },
    neutral: {
      main: "#20272B",
      light: "#44484F",
      dark: "#20272B",
      contrastText: "#20272B",
      "900": "#20272B",
      "700": "#44484F",
      "500": "#697586",
      "300": "#9AA4B2",
      "100": "#D5DEE5",
      "50": "#EDF5FA",
    },
    gGrey: {
      main: "#333333",
      light: "#333333",
      dark: "#333333",
      contrastText: "#333333",
      "900": "#20272B",
      "700": "#4F4F4F",
      "500": "#828282",
      "300": "#BDBDBD",
      "100": "#E0E0E0",
      "50": "#ECECEC",
    },
    greyBg: {
      main: "#333333",
      light: "#333333",
      dark: "#333333",
      contrastText: "#333333",
      "200": "#F1F0EC",
      "100": "#F8F8F8",
    },
    neutralBg: {
      main: "#333333",
      light: "#333333",
      dark: "#333333",
      contrastText: "#333333",
      "200": "#D3DCE3",
      "100": "#F1F6FA",
    },
    primaryDark: {
      main: "#163F4A",
      light: "#163F4A",
      dark: "#163F4A",
      contrastText: "#163F4A",
      "900": "#163F4A",
      "700": "#31535F",
      "500": "#4B6873",
      "300": "#657B89",
      "100": "#7F909D",
      "50": "#8D9AA8",
    },
    orange: {
      main: "#D5864E",
      light: "#D5864E",
      dark: "#D5864E",
      contrastText: "#D5864E",
      "700": "#D5864E",
      "400": "#E6B695",
      "100": "#F7E7DC",
    },
    info: {
      main: "#007BFF",
      light: "#007BFF",
      dark: "#007BFF",
      contrastText: "#007BFF",
      "700": "#007BFF",
      "400": "#007BFF",
      "100": "#E6F2FF",
    },
  },
});
